export const ensureLeadingSlash = (path: string): string => {
  return path.startsWith('/') ? path : `/${path}`;
};

export const clinicPath = (tenant: string, clinicNumber: string, subPath: string): string => {
  return `/${tenant}/${clinicNumber}${ensureLeadingSlash(subPath)}`;
};

export const sitePath = (tenant: string, subPath: string): string => {
  return `/${tenant}${ensureLeadingSlash(subPath)}`;
};

/**
 * Clinic Portal API Path Helpers
 * All clinic portal API endpoints now use prefix: /clinic/{site_type}/...
 */

/**
 * Build clinic portal auth API path (site-scoped, no clinic_number)
 * Example: clinicAuthPath('medix', '/auth/login') => '/clinic/medix/auth/login'
 */
export const clinicAuthPath = (siteType: string, subPath: string): string => {
  return `/clinic/${siteType}${ensureLeadingSlash(subPath)}`;
};

/**
 * Build clinic portal data API path (with clinic_number)
 * Example: clinicApiPath('medix', 'CL001', '/patients') => '/clinic/medix/CL001/patients'
 */
export const clinicApiPath = (siteType: string, clinicNumber: string, subPath: string): string => {
  return `/clinic/${siteType}/${clinicNumber}${ensureLeadingSlash(subPath)}`;
};

/**
 * Build massager portal auth API path (site-scoped, no clinic_number).
 * Used for login/logout/user/refresh where clinic_number is not part of the URL.
 * Example: massagerAuthPath('medix', '/auth/login') => '/massager/medix/auth/login'
 */
export const massagerAuthPath = (siteType: string, subPath: string): string => {
  return `/massager/${siteType}${ensureLeadingSlash(subPath)}`;
};

/**
 * Build massager portal business API path (clinic-scoped, requires clinic_number).
 * Used for all massager endpoints except auth (schedules/visits/uploads/etc).
 * Example: massagerApiPath('medix', 'CL001', '/schedules') => '/massager/medix/CL001/schedules'
 */
export const massagerApiPath = (
  siteType: string,
  clinicNumber: string,
  subPath: string
): string => {
  return `/massager/${siteType}/${clinicNumber}${ensureLeadingSlash(subPath)}`;
};
